// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cursor-pointer[data-v-40826b90] {\n    cursor: pointer;\n}\n.input-add-image label[data-v-40826b90] {\n    display: block;\n}\n.container[data-v-40826b90] {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n", ""]);
// Exports
module.exports = exports;
